import Vue from 'vue';
import loadImg from './assets/images/default-loading.jpg';
import loadImgErr from './assets/images/default-loading-error.jpg';
import App from './App.vue';
import VueRouter from 'vue-router';
import Vant from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/index.css';
// import VueLazyload from 'vue-lazyload'
import './css/common.scss';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import store from './store/init';
import VueClipboard from 'vue-clipboard2';
var sensors = require('sa-sdk-javascript');
import utils from './plugin/utils';
let ver = utils.getUrlKey('ver');
Vue.use(VueClipboard);
Vue.use(Viewer);
Vue.use(Vant);
Vue.use(VueRouter);
Vue.use(Lazyload, {
  preLoad: 1.3,
  error: loadImgErr,
  loading: loadImg,
  attempt: 1,
})
Viewer.setDefaults({
  toolbar: false,
  navbar: false,
  title: false,
  zoomable: false,
  movable: false,
  rotatable: false,
  scalable: false
})
Vue.config.productionTip = false;
Vue.prototype.sensors = sensors;
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes: [
    { path: "/h", name: 'h', component: () => import('./components/helpJump.vue'), props: true }, // 历史记录辅助路由
    // { path: "*", redirect:'/Home' }, // 无效路由跳回首页
    {
      path: "/", component: () => import('./components/Layout.vue'), props: true,
      children: [
        {
          path: '/',
          name: "Home",
          component: () => import('./components/Home.vue'), props: true
        },
        // {
        //   path: '/homeList',
        //   name:"homeList",
        //   component: () => import('./components/homeList.vue'), props: true
        // },
      ],
      //  redirect:'/Home'
    },
    // { path: "/member", name:'member' , component: () => import('./components/member.vue') , props: true },
    // { path: "/taskHome", name:'taskHome' , redirect: '/task', component: () => import('./components/taskHome.vue') , props: true ,
    //   children:[
    //     {
    //       path: '/task',
    //       name:"task",
    //       component: () => import('./components/task.vue'), props: true
    //     },
    //     {
    //       path: '/Moretask',
    //       name:"Moretask",
    //       component: () => import('./components/Moretask.vue'), props: true
    //     },
    //     {
    //       path: '/buseiness',
    //       name:"buseiness",
    //       component: () => import('./components/buseiness.vue'), props: true
    //     },
    //   ],
    // },
    // { path: "/userInfo", name:'userInfo' , component: () => import('./components/userInfo.vue') , props: true },
    { path: "/moreList", name: 'moreList', component: () => import('./components/moreList.vue'), props: true },
    // { path: "/moreList2", name:'moreList2' , component: () => import('./components/moreList2.vue') , props: true },
    { path: "/hostList", name: 'hostList', component: () => import('./components/hostList.vue'), props: true },
    // { path: "/newHostList", name:'newHostList' , component: () => import('./components/newHostList.vue') , props: true },
    { path: "/hosDetails", name: 'hosDetails', component: () => import('./components/hosDetails.vue'), props: true },
    // { path: "/history", name:'history' , component: () => import('./components/history.vue') , props: true },
    { path: "/fictionList", name: 'fictionList', component: () => import('./components/fictionList.vue'), props: true },
    // { path: "/login", name:'login' , component: () => import('./components/login.vue') , props: true },
    // { path: "/feedback", name:'feedback' , component: () => import('./components/feedback.vue') , props: true },
    // { path: "/buseiness", name:'buseiness' , component: () => import('./components/buseiness.vue') , props: true },
    { path: "/player", name: 'player', component: () => import('./components/player.vue'), props: true },
    { path: "/special", name: 'special', component: () => import('./components/special.vue'), props: true },
    { path: "/specialDesc/:id", name: 'specialDesc', component: () => import('./components/specialDesc.vue'), props: true },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


if (ver) {
  var versionNumber1 = ver.replace(/[a-zA-Z]/g, (match, i) => match.charCodeAt()).replace(/[^\d]/g, '') - 0;
}// console.log(versionNumber1)
if (versionNumber1 >= 228) {
  sensors.init({
    // server_url: 'https://shence.jiushengliye.com/sa?project=YDA44',
    server_url: 'https://shence.jiushengliye.com/sa?project=YDA44TEST',
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      show_log: true,
      //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
    }
  });
  router.afterEach(() => {
    Vue.nextTick(() => {
      sensors.quick("autoTrackSinglePage");
    })
  });
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
